import {
    FETCH_15MIN_REQUESTED,
    FETCH_15MIN_SUCCEEDED,
    FETCH_15MIN_FAILED,
    FETCH_1HOUR_REQUESTED,
    FETCH_1HOUR_SUCCEEDED,
    FETCH_1HOUR_FAILED,
    FETCH_6HOUR_REQUESTED,
    FETCH_6HOUR_SUCCEEDED,
    FETCH_6HOUR_FAILED,
} from './constants';

export function fetch15MinRequested({ startDate, endDate }) {
    return {
        type: FETCH_15MIN_REQUESTED,
        startDate,
        endDate,
    };
}

export function fetch15MinSucceeded(data) {
    return {
        type: FETCH_15MIN_SUCCEEDED,
        data,
    };
}

export function fetch15MinFailed(error) {
    return {
        type: FETCH_15MIN_FAILED,
        error,
    };
}

export function fetch1HourRequested({ startDate, endDate }) {
    return {
        type: FETCH_1HOUR_REQUESTED,
        startDate,
        endDate,
    };
}

export function fetch1HourSucceeded(data) {
    return {
        type: FETCH_1HOUR_SUCCEEDED,
        data,
    };
}

export function fetch1HourFailed(error) {
    return {
        type: FETCH_1HOUR_FAILED,
        error,
    };
}

export function fetch6HourRequested({ startDate, endDate }) {
    return {
        type: FETCH_6HOUR_REQUESTED,
        startDate,
        endDate,
    };
}

export function fetch6HourSucceeded(data) {
    return {
        type: FETCH_6HOUR_SUCCEEDED,
        data,
    };
}

export function fetch6HourFailed(error) {
    return {
        type: FETCH_6HOUR_FAILED,
        error,
    };
}
